import { useContext } from 'react';
import { MenuProfile } from '../header/MenuProfile';
import { MenuDropdown } from '../header/MenuDropdown';
import { Home, CreditCard, Star, Terminal, LogOut, Moon, Sun } from 'react-feather'
import { open } from '@/redux/app/actions/navigation';
import { colors } from '../ui-elements/Main/MainTheme';
import { useDispatch, useSelector } from 'react-redux';
import { AccountInfoContext } from '../account/account-info';
import { OrgInfoContext } from '../organization/org-info';
import { useNavigationActions } from '@/lib/navigation';
import { signOut } from '@/redux/app/actions/settings';
import { setThemePreference } from '@/redux/app/actions/theme';
import { Avatar } from './Avatar';
import { accountBillingPath, organizationPath } from '@/helpers/app/routes';
import { UserInfoContext } from '../user/user-info';

export const ProfileAndSettings = () => {
  const dispatch = useDispatch();
  const { navigate } = useNavigationActions();
  const { subdomain } = useContext(AccountInfoContext);
  const { hashId } = useContext(OrgInfoContext);
  const { canViewBilling, admin }  = useContext(UserInfoContext);
  const { canViewOrg } = useContext(OrgInfoContext);
  const themePreference = useSelector((state: any) => state.theme?.preference ?? 'light');
  const isDark = themePreference === 'dark';

  const size = 18;

  const menuItems = [
    ...((canViewOrg || admin) ? [{
      title: 'Manage Organization',
      icon: <Home size={size}/>,
      callback: () => navigate({ path: organizationPath(hashId), params: {} })
    }] : []),
    ...(canViewBilling ? [{
      title: 'Billing & Subscription',
      icon: <CreditCard size={size}/>,
      callback: () => navigate({ path: accountBillingPath(subdomain), params: {} })
    }] : []),
    { title: 'Whats New', icon: <Star size={size}/>, callback: () => dispatch(open({ path: `https://releases.avochato.com`, params: {} }))},
    { title: 'Developers', icon: <Terminal size={size}/>, callback: () => dispatch(open({ path: `${window.location.origin}/docs`, params: {} }))},
    ...(admin ? [{
      title: 'Toggle Stage',
      icon: <Star size={size}/>,
      callback: () => {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({version: "2", method: "switch-stage"}));
        }
      }}] : []),
    {
      title: isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode',
      icon: isDark ? <Sun size={size} /> : <Moon size={size} />,
      callback: () => dispatch(setThemePreference(isDark ? 'light' : 'dark')),
    },
    { title: 'Sign Out', icon: <LogOut size={size} color={colors.red}/>, textColor: colors.red, callback: () => dispatch(signOut())},
  ];


  return (
    <MenuDropdown
      tooltip="Profile & Settings"
      menuHeader={<MenuProfile />}
      menuItems={menuItems}
      trigger={<Avatar />}
    />
  )
}